export default "__VITE_ASSET__eb33671b__"